import { Injectable } from '@angular/core';

import { CiudadDialogComponent } from 'src/app/shared/components/ciudad/ciudad-dialog.component';
import { ProvinciaDialogComponent } from 'src/app/shared/components/provincia-dialog/provincia-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class DataSetComponentService {
  COMPONENTS: any = {
    "ProvinciaDialogComponent": ProvinciaDialogComponent,
    "CiudadDialogComponent": CiudadDialogComponent
  }

  get(name: string): any {
    return this.COMPONENTS[name];
  }
}
